'use client';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { Button, ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { Modal } from '@/components/Modal';
import { NamesSteps } from '@/helpers/auth';
import { useCommonStore } from '@/store';

import { ScLeaveRegistration, ScTitle } from './styled';

export type LeaveRegistrationProps = {
  onClose: () => void;
  onOpenRegistration: () => void;
};

export const LeaveRegistrationModal: FC<LeaveRegistrationProps> = ({
  onClose,
  onOpenRegistration,
}) => {
  const { t } = useTranslation('leaveRegistration');

  const { currentRegistrationStep: step } = useCommonStore(
    useShallow((state) => ({
      currentRegistrationStep: state.currentRegistrationStep,
    }))
  );

  const isFirstStep = step === NamesSteps.PRIMARY_INFORMATION;

  return (
    <Modal>
      <ScLeaveRegistration>
        <ButtonClose
          gray
          onClick={isFirstStep ? onOpenRegistration : onClose}
          top={8}
          right={8}
        />
        <ImageComponent
          width={160}
          height={160}
          src={`/leaveRegistration/exit-${step}.webp`}
          alt="thinking emoji"
          className="emoji-img"
        />
        <ScTitle>{t(`${step}.title`)}</ScTitle>
        <p className="subTitle">{t(`${step}.subTitle`)}</p>
        {isFirstStep ? (
          <div className="firstStepButtons">
            <Button wide primary large onClick={onOpenRegistration}>
              {t(`${step}.primaryBtn`)}
            </Button>
            <Button className="close" white wide small onClick={onClose}>
              {t(`${step}.secondaryBtn`)}
            </Button>
          </div>
        ) : (
          <div className="restStepsButtons">
            <Button blackTransparent wide large onClick={onClose}>
              {t(`${step}.secondaryBtn`)}
            </Button>
            <Button wide primary large onClick={onOpenRegistration}>
              {t(`${step}.primaryBtn`)}
            </Button>
          </div>
        )}
      </ScLeaveRegistration>
    </Modal>
  );
};
